import styled from "styled-components"

export const DropdownItemContainer = styled.span`
  padding: 3px 20px;

  display: block;
`
